import type { SVGProps } from 'react'

const Copy = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 13.6V14C7 15.1046 7.89543 16 9 16H14C15.1046 16 16 15.1046 16 14V9C16 7.89543 15.1046 7 14 7H13.6"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        d="M4 6C4 4.89543 4.89543 4 6 4H11C12.1046 4 13 4.89543 13 6V11C13 12.1046 12.1046 13 11 13H6C4.89543 13 4 12.1046 4 11V6Z"
        stroke="currentColor"
        strokeWidth="1.25"
      />
    </svg>
  )
}
export default Copy
